import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ServiceDirectory.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ServiceDirectory = ({ onClose, language = 'ru' }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const translations = {
    kk: {
      title: 'Қала қызметтері',
      closeBtn: 'Жабу',
      noServices: 'Қызметтер табылмады',
      description: 'Қызмет сипаттамасы'
    },
    ru: {
      title: 'Службы города',
      closeBtn: 'Закрыть',
      noServices: 'Службы не найдены',
      description: 'Описание службы'
    }
  };

  const t = translations[language];

  // Список всех служб города
  const cityServices = [
    {
      id: 'emergency',
      name_kk: 'Төтенше жағдайлар қызметі',
      name_ru: 'Экстренные службы',
      icon: '🚨',
      color: '#e53e3e',
      description_kk: 'Өрт сөндірушілер, жедел медициналық көмек, полиция',
      description_ru: 'Пожарные, скорая медицинская помощь, полиция',
      phone: '101, 102, 103'
    },
    {
      id: 'municipal',
      name_kk: 'Коммуналдық қызмет',
      name_ru: 'ЖКХ служба',
      icon: '🏢',
      color: '#3182ce',
      description_kk: 'Жылыту, су жабдықтау, канализация',
      description_ru: 'Отопление, водоснабжение, канализация',
      phone: '115'
    },
    {
      id: 'kazaktelecom',
      name_kk: 'Қазақтелеком',
      name_ru: 'Казахтелеком',
      icon: '📞',
      color: '#2d3748',
      description_kk: 'Интернет, телефон байланысы',
      description_ru: 'Интернет, телефонная связь',
      phone: '123'
    },
    {
      id: 'electricity',
      name_kk: 'Электр энергиясы қызметі',
      name_ru: 'Служба электроснабжения',
      icon: '⚡',
      color: '#d69e2e',
      description_kk: 'Электр энергиясын жабдықтау',
      description_ru: 'Электроснабжение',
      phone: '139'
    },
    {
      id: 'improvement',
      name_kk: 'Абаттандыру қызметі',
      name_ru: 'Служба благоустройства',
      icon: '🌳',
      color: '#38a169',
      description_kk: 'Көше тазалығы, жасыл аймақтар',
      description_ru: 'Уборка улиц, зеленые зоны',
      phone: '142'
    },
    {
      id: 'traffic',
      name_kk: 'Жол полициясы',
      name_ru: 'Дорожная полиция',
      icon: '🚔',
      color: '#3182ce',
      description_kk: 'Жол қауіпсіздігі, жол ережелері',
      description_ru: 'Безопасность дорожного движения',
      phone: '102'
    },
    {
      id: 'healthcare',
      name_kk: 'Денсаулық сақтау',
      name_ru: 'Здравоохранение',
      icon: '🏥',
      color: '#e53e3e',
      description_kk: 'Медициналық қызметтер',
      description_ru: 'Медицинские услуги',
      phone: '103'
    },
    {
      id: 'education',
      name_kk: 'Білім беру',
      name_ru: 'Образование',
      icon: '🎓',
      color: '#805ad5',
      description_kk: 'Мектептер мен балабақшалар',
      description_ru: 'Школы и детские сады',
      phone: '144'
    }
  ];

  useEffect(() => {
    setServices(cityServices);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="service-directory-overlay">
        <div className="service-directory">
          <div className="loading">{language === 'kk' ? 'Жүктелуде...' : 'Загрузка...'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="service-directory-overlay">
      <div className="service-directory">
        <div className="service-directory-header">
          <h2>{t.title}</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <div className="services-grid">
          {services.length === 0 ? (
            <div className="no-services">{t.noServices}</div>
          ) : (
            services.map(service => (
              <div key={service.id} className="service-card">
                <div className="service-header">
                  <div className="service-icon" style={{ backgroundColor: service.color }}>
                    {service.icon}
                  </div>
                  <div className="service-info">
                    <h3>{service[`name_${language}`] || service.name_ru}</h3>
                    <p className="service-phone">📞 {service.phone}</p>
                  </div>
                </div>
                <div className="service-description">
                  {service[`description_${language}`] || service.description_ru}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceDirectory;